export default __webpack_public_path__ + "static/media/FPAY Press Release Final 2016 06 29 .94b7f221.pdf";